function getAvailabilityTabData(selectedId) {
    const availabilityData = [
        {
            id: 'all',
            label: 'All',
            value: null,
            selected: false,
        },
        {
            id: 'inStock',
            label: 'In Stock',
            value: 1,
            selected: false,
        },
        {
            id: 'soldOut',
            label: 'Sold Out',
            value: 2,
            selected: false,
        },
        {
            id: 'unavailable',
            label: 'Unavailable',
            value: 8,
            selected: false,
        },
    ];

    const selectedAvailability = availabilityData.find((availability) => availability.id === selectedId);
    selectedAvailability ? (selectedAvailability.selected = true) : (availabilityData[0].selected = true);

    return availabilityData;
}

export default getAvailabilityTabData;
